import React from 'react'
import EduBasicTemplate from 'components/branch/eduTemplate/EduBasicTemplate'


function Edubasic() {
    return <EduBasicTemplate />
}

export default Edubasic